import React from 'react';
import { observer } from 'mobx-react';

import { Button } from '@infoods/lifebase-ui';
import AddRoundedIcon from '@mui/icons-material/AddRounded';

import { PageTitle } from '../../../../shared/components/ui-components';
import { loggedInUserDataStore } from '../../../../shared/stores/loggedInUserDataStore';

const ChallengesListPageTitle = observer(() => {
  const { isEntity } = loggedInUserDataStore;

  return (
    <PageTitle title="Challenges">
      {isEntity && (
        <Button
          variant="contained"
          size="medium"
          startIcon={<AddRoundedIcon />}
          href="#!/challenge-create"
        >
          Add a New Challenge
        </Button>
      )}
    </PageTitle>
  );
});

export { ChallengesListPageTitle };
